import React from 'react'
import { Empty } from 'antd'

export default ({ ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} {...props} />
)
